import AttendanceHooks from "./hooks";
import AttendanceHelpers from "./helpers";
import AttendanceModals from "./modals";
import AttendanceBlocks from "./blocks";
import AttendanceLists from "./lists";

import "./attendance.scss";


const Attendance = {
    Hooks: AttendanceHooks,
    Helpers: AttendanceHelpers,
    Modals: AttendanceModals,
    Blocks: AttendanceBlocks,
    Lists: AttendanceLists
};

export default Attendance;
